import { getAdjustedDirection, getClipPolygonParams, INITIAL_FRAME_OFFSET } from '../../utils';
export function getNames(_) {
  return ['motion-revealIn'];
}
const DIRECTIONS = ['top', 'right', 'bottom', 'left'];
function getClipStart(rotateZ, direction) {
  const clipDirection = getAdjustedDirection(DIRECTIONS, direction, rotateZ);
  return getClipPolygonParams({
    direction: clipDirection,
    minimum: 0
  });
}
export function web(options, dom) {
  prepare(options, dom);
  return style(options);
}
export function style(options) {
  const {
    direction = 'left'
  } = options.namedEffect;
  const [revealIn] = getNames(options);
  const easing = options.easing || 'cubicInOut';
  const start = getClipStart(0, direction);
  const end = getClipPolygonParams({
    direction: 'initial'
  });
  const custom = {
    '--motion-clip-start': start
  };
  return [{
    ...options,
    easing,
    name: revealIn,
    custom,
    keyframes: [{
      offset: 0,
      opacity: 0,
      easing: 'step-end'
    }, {
      offset: INITIAL_FRAME_OFFSET,
      opacity: 'var(--comp-opacity, 1)',
      clipPath: `var(--motion-clip-start, ${start})`
    }, {
      clipPath: end
    }]
  }];
}
export function prepare(options, dom) {
  const {
    direction = 'left'
  } = options.namedEffect;
  if (dom) {
    let rotation = '0deg';
    dom.measure(target => {
      if (!target) {
        return;
      }
      rotation = getComputedStyle(target).getPropertyValue('--comp-rotate-z') || '0deg';
    });
    dom.mutate(target_ => {
      target_ == null || target_.style.setProperty('--motion-clip-start', getClipStart(parseInt(rotation, 10), direction));
    });
  }
}
//# sourceMappingURL=RevealIn.js.map